import { msg } from '../messages'
import * as Util from '../util'

export function numericRange(min: number, max: number) {
  return (value: string) => {
    if (!Util.isEmpty(value) && (value.length < min || value.length > max)) {
      return msg('numericRange', value, min, max)
    }
  }
}
